import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AppService } from 'src/app/app.service';
import { NotificationsService } from 'src/app/modules/notifications/notifications-service';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.scss']
})
export class Header2Component implements OnInit {
  @Input() title = '';
  @Input() showButton = '';
  @Input() routeInfo: any;
  @Input() isLoginPage: boolean;

  isUnreadNotificationAvailable;
  logoUrl: string | undefined = undefined;

  constructor(
    private router: Router,
    public menuService: SideMenuService,
    private appService: AppService,
    private storageService: StorageService,
    private notificationsService: NotificationsService,
    private modalCtrl: ModalController
  ) { }

  async ngOnInit() {
    // console.log(this.title)
    // console.log(
    //   `Show Button =', ${this.showButton}. RoutingInfo = ${this.routeInfo}, IsLoginPage = ${this.isLoginPage} `
    // );

    this.isUnreadNotificationAvailable = await this.storageService.getFromLocalStorage(
      'notificationIds'
    );
    this.appService.logoUrl.subscribe(url => {
      this.logoUrl = url;
    });
    this.notificationsService.initializeData('Notifications');
  }
  closeModal() {
    // console.log("rrrrr")
    this.modalCtrl.dismiss()
  }
  openNotificationPage() {
    this.menuService.selectedIndex = this.menuService.appPages
      .getValue()
      .findIndex((sMenu) => sMenu.uid === 'Notifications');
    this.router.navigate(['notifications/Notifications'], { replaceUrl: true });
  }

  canShow() {
    if (this.isLoginPage) {
      return false;
    }
    const notificationIconValue = this.appService.systemSettings
      .notification_icon;

    if (notificationIconValue === 'always') {
      return true;
    } else if (notificationIconValue === 'only-if-unread') {
      return this.isUnreadNotification();
    } else {
      return false;
    }
  }

  isUnreadNotification() {
    return this.isUnreadNotificationAvailable?.length > 0 ? true : false;
  }
}

